import { SETTINGS_NAVIGATION_SECTIONS } from '@/navigation/constants/SettingsNavigationSections';
import { useCurrentWorkspace } from '@/session/hooks/useCurrentWorkspace';

export const useSettingsNavigationSections = () => {
  const { currentMember } = useCurrentWorkspace();
  return SETTINGS_NAVIGATION_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(
      (item) =>
        item.permission === undefined ||
        currentMember.permissions.includes(item.permission),
    ),
  }));
};
